import TotpGuard from '@/app/component/guard/totp'
import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import Campaigns from '@/app/module/campaigns'
import Notifications from '@/app/module/notifications'
import { MatchProps } from '@/app/types'

type Props = {
  match: MatchProps
}

function CampaignsPage({ match }: Props) {
  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title="Campaigns - engageSPARK">
        <AuthHeader currentPage={PAGE.CAMPAIGNS.INDEX} />
        <TotpGuard>
          <Campaigns />
        </TotpGuard>
        <Notifications />
      </Layout>
    </AuthGuard>
  )
}

export default CampaignsPage
